export default __webpack_public_path__ + "static/media/globe_blue.926b6f6c.svg";